module.exports = __webpack_public_path__ + "img/check-icon.4f5dc28f.svg";